<script>
  import { computed } from '@nuxtjs/composition-api'
  import { useAttribute } from '@/composables/useAttribute'
  import { productAttributes } from '@/constants/products.module'
  import Badge from '@/components/Ecommerce/Badge'
  import { productGetters } from '@/composables/propeller/getters'
  import { setProductsListTracking } from '~/utils/utils'
  import { gtmSendEvent } from '~/utils/gtm-send-event'

  export default {
    name: 'ProductRelatedProductSmall',
    components: {
      Badge,
    },
    props: {
      product: {
        type: Object,
        required: true
      }
    },
    setup (props, { root }) {
      const productType = computed(() => {
        return useAttribute(props.product, productAttributes.brand)
      })

      const coverImage = computed(() => {
        return !Array.isArray(props.product)
          ? productGetters.getCoverImage(props.product)
          : null
      })

      const trackProductClick = (product, productType, level) => {
        const productList = setProductsListTracking([{
          ...product,
          name: productGetters.getName(product),
          productType,
          level,
        }])
        gtmSendEvent('select_item', {
          ecommerce: {
            currency: 'EUR',
            items: productList
          },
          item_list_name: 'Productpagina',
          item_list_id: 'productpagina'
        }, null, true)
      }
      return {
        productType,
        coverImage,
        trackProductClick,
        productName: computed(() => productGetters.getName(props.product)),
        // Fall back to the full name when the related-product payload omits the
        // localized `shortNames` (list-shaped query), so the title isn't blank.
        productShortName: computed(() => productGetters.getShortName(props.product) || productGetters.getName(props.product)),
        id: computed(() => productGetters.getId(props.product) || props.product.id),
        slug:  computed(() => productGetters.getSlug(props.product) || props.product.slug),
      }
    }
  }
</script>

<template>
  <div 
    class="product-related-product-small bg-blue-100 rounded p-4 m-4 "       
    @click="() => trackProductClick(product, productType, levels, price)"
  >
    <nuxt-link
      :to="`/producten/${id}/${slug}`"
      class="h-full"
    >
      <div class="flex">
        <div>
          <img
            :src="coverImage"
            :alt="productName"
            class="max-h-14 w-auto mr-5"
          >
        </div>
        <div>
          <Badge
            v-if="productType !== 'Voordeelpakket' && productType !== 'Examenbuddy'"
            small
            primary
            rounded
            class="mb-2 md:mb-2"
          >
            Bespaar 20%
          </Badge>
          <h4 class="text-lg">{{ productType.value }}  {{ productShortName }}</h4>
        </div>
      </div>
    </nuxt-link>
  </div>
</template>
